import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Itaobuy Prezzi: Guida Completa a Costi, Spedizione e Risparmio',
  url: `${siteUrl}/itaobuy-prezzi`,
  description: 'Scopri quanto costa davvero usare itaobuy spreadsheet e come ottimizzare il tuo budget per risparmiare su ogni acquisto.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function PrezziPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ PREZZI</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Itaobuy Prezzi: Guida Completa a Costi, Spedizione e Risparmio
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Scopri quanto costa davvero usare <strong className="text-background-50">itaobuy spreadsheet</strong> e come ottimizzare il tuo budget per risparmiare su ogni acquisto.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per esplorare le categorie e confrontare i prezzi.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Quanto Costa Itaobuy?</h2>
              <p className="mb-4">I <strong className="text-foreground-950">prezzi su itaobuy</strong> sono generalmente molto competitivi rispetto ai canali tradizionali. Il database ti permette di confrontare diverse opzioni per lo stesso prodotto, aiutandoti a trovare il miglior rapporto qualità-prezzo. I costi variano in base alla categoria: dalle sneakers (20-80€) agli accessori (5-30€), fino ai capi di abbigliamento (15-60€).</p>
              <p>Per una panoramica sui costi di consegna, consulta la <Link to="/itaobuy-spedizione-italia" className="text-primary-600 font-medium hover:underline">guida alla spedizione</Link>.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Strategie per Risparmiare</h2>
              <p className="mb-4">Per <strong className="text-foreground-950">risparmiare con itaobuy spreadsheet</strong>, sfrutta gli acquisti combinati per ridurre i costi di spedizione. Monitora le offerte stagionali e le promozioni condivise dalla community. Il database è aggiornato regolarmente con le migliori offerte disponibili.</p>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Inizia a Risparmiare</h3>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">Itaobuy prezzi</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}